import { IteratorExpression } from '../Expression.js';
import { Utils } from '../../Utils.js';
export class SelectExpression extends IteratorExpression {
    evaluate(visitor, localVariables) {
        const collection = this.getSource()
            .evaluate(visitor, localVariables);
        if (collection instanceof Array) {
            return collection.filter(c => {
                const variables = {};
                if (this.getIterators()) {
                    variables[this.getIterators()[0]] = c;
                }
                else {
                    const variableName = Utils.getVariableName(this);
                    variables[variableName.getVariable()] = c;
                }
                return this.getBody()
                    .evaluate(visitor, Object.assign(Object.assign({}, localVariables), variables));
            });
        }
        else {
            return [];
        }
    }
}
//# sourceMappingURL=SelectExpression.js.map